// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"3b53517f","111":"3b53517f","365":"3b53517f","526":"3b53517f","576":"3b53517f"}[chunkId] + ".chunk.css";
};